import { ServiceOSGlobalSettings } from './getServiceOSGlobalSettings';

interface PasswordResetQueryParams {
  searchParams: URLSearchParams | null;
  values: {
    token: string | null;
  };
}

export function getServiceOSPasswordResetQueryParams(
  serviceOSGlobalSettings: ServiceOSGlobalSettings
) {
  const { tokenQueryParam = null } = serviceOSGlobalSettings?.passwordReset || {};

  const params: PasswordResetQueryParams = {
    searchParams: null,
    values: {
      token: null,
    },
  };

  if (typeof window === 'undefined') {
    return params;
  }

  if (!tokenQueryParam) {
    return params;
  }

  const searchParams = new URLSearchParams(window.location.search);

  const token = searchParams.get(tokenQueryParam) || null;

  if (!token) {
    return params;
  }

  params.searchParams = searchParams;
  params.values.token = token;

  return params;
}
